import apiClient from '../server';

export const fetchProfiles = async (pagination = true, page, limit, isActive, isVerified, search, profileType = "M") => {
  try {
    // Build query parameters
    const params = new URLSearchParams();
    params.append('pagination', pagination);
    params.append('page', page);
    params.append('limit', limit);
    
    // Only add filters if they are defined
    if (isActive !== undefined) params.append('isActive', isActive);
    if (isVerified !== undefined) params.append('isVerified', isVerified);
    if (search) params.append('search', search);
    if (profileType) params.append('profileType', profileType);

    console.log('Fetching profiles with URL:', `/profiles/search?${params.toString()}`);
    
    const response = await apiClient.get(`/profiles/search?${params.toString()}`);
    console.log('Profiles API response:', response);
    
    return response.data;
  } catch (error) {
    console.error('Error fetching profiles:', error);
    if (error.response) {
      console.error('Error response data:', error.response.data);
      console.error('Error response status:', error.response.status);
    }
    throw error;
  }
};

export const createProfile = async (profileData) => {
  try {
    // Ensure all required fields are present and properly formatted
    const formattedData = {
      ...profileData,
      // Ensure numeric fields are numbers
      followersInstagram: Number(profileData.followersInstagram) || 0,
      followersSpotify: Number(profileData.followersSpotify) || 0,
      followersAppleMusic: Number(profileData.followersAppleMusic) || 0,
      followersSoundcloud: Number(profileData.followersSoundcloud) || 0,
      // Ensure boolean fields are booleans
      isVerified: Boolean(profileData.isVerified),
      isValidated: Boolean(profileData.isValidated),
      isActive: Boolean(profileData.isActive),
      isTrending: Boolean(profileData.isTrending),
      isFeatured: Boolean(profileData.isFeatured),
      isClaimed: Boolean(profileData.isClaimed),
      // Ensure string fields are strings or null
      picture: profileData.picture || null,
      banner: profileData.banner || null,
      itunesMusicID: profileData.itunesMusicID || null,
      gender: profileData.gender || null,
    };

    const response = await apiClient.post(`/profiles/create`, formattedData);
    return response.data;
  } catch (error) {
    console.error("Error creating profile:", error);
    throw error;
  }
};


export const getProfileById = async(ProfileId)=>{
  try{
      console.log('🔍 [getProfileById] Attempting to fetch profile with ID:', ProfileId);
      
      // Use the apiClient which already has the base URL configured
      const response = await apiClient.get(`/profiles/get/${ProfileId}`);
      console.log("✅ [getProfileById] Success - profile data:", response.data);
      return response.data.data.profile;
  }catch(error){
    console.error('❌ [getProfileById] Error fetching profile:', error);
    throw error;
  }
}

export const getProfileMembers = async(ProfileId) => {
  try{
    const response=await apiClient.get(`/members/profile/${ProfileId}`);
    return response.data.data;
  }catch(error){
    console.error('error getting profile members : ', error);
    throw error;
  }
}

export const UpdateProfile = async(profileId,profile) =>{
  try{
    const response=await apiClient.patch(`/profiles/updatesuperadmin/${profileId}`, profile);
    console.log(response);
    return response;
  }catch(error){
    console.error("error updating profile", error);
    throw error;
  }
}
export const deleteProfile=async(profileId)=>{
  try{
    const response=await apiClient.delete(`profiles/delete/${profileId}`)
  }catch(error){
    console.error("error deleteing profile",error);
  }
}
export const deleteProfileMember = async (profileId, memberId) => {
  try {
    const response = await apiClient.delete(`members/delete/${memberId}`);
    return response.data;
  } catch (error) {
    throw new Error("Error deleting profile member");
  }
}

export const createMember = async (memberData) => {
  try {
    const response = await apiClient.post("/members/create", memberData);
    return response.data;
  } catch (error) {
    console.error("Error creating member:", error);
    throw error;
  }
};
export const inviteMember = async (memberData) => {
  try {
    const response = await apiClient.post("/invitations/create", memberData);
    return response.data;
  } catch (error) {
    console.error("Error invitations member:", error);
    throw error;
  }
};
export const updateMember = async (memberData,id) => {
  try {
    const response = await apiClient.patch(`/members/update/${id}`, memberData);
    return response.data;
  } catch (error) {
    console.error("Error update member:", error);
    throw error;
  }
};

export const searchProfilesMeili = async (query = '', filters = {}) => {
  try {
    // Build query parameters
    const params = new URLSearchParams();
    
    if (query) params.append('q', query);
    if (filters.musicTypes) params.append('musicTypes', filters.musicTypes);
    if (filters.city) params.append('city', filters.city);
    if (filters.country) params.append('country', filters.country);
    if (filters.profileType) params.append('profileType', filters.profileType);
    if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
    if (filters.isVerified !== undefined) params.append('isVerified', filters.isVerified);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);

    console.log('🔍 [MeiliSearch] Searching profiles with URL:', `/meilisearch/search/profiles?${params.toString()}`);
    
    const response = await apiClient.get(`/meilisearch/search/profiles?${params.toString()}`);
    console.log('🔍 [MeiliSearch] Response:', response.data);
    
    return {
      data: response.data.hits || [],
      total: response.data.estimatedTotalHits || 0,
      processingTime: response.data.processingTimeMs || 0
    };
  } catch (error) {
    console.error('🔍 [MeiliSearch] Error searching profiles:', error);
    if (error.response) {
      console.error('🔍 [MeiliSearch] Error response data:', error.response.data);
      console.error('🔍 [MeiliSearch] Error response status:', error.response.status);
    }
    throw error;
  }
};

// Suggestion API functions
export const getProfileSuggestions = async (musicTypes, city, limit = 50, page = 1) => {
  try {
    const params = new URLSearchParams({
      musicTypes: Array.isArray(musicTypes) ? musicTypes.join(',') : musicTypes,
      limit: limit,
      page: page,
      pagination: 'true'
    });

    if (city) {
      params.append('city', city);
    }

    console.log('🔍 [Suggestions] Fetching suggestions with URL:', `/profiles/suggestion/feed?${params.toString()}`);
    
    const response = await apiClient.get(`/profiles/suggestion/feed?${params.toString()}`);
    console.log('🔍 [Suggestions] Response:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('🔍 [Suggestions] Error fetching suggestions:', error);
    if (error.response) {
      console.error('🔍 [Suggestions] Error response data:', error.response.data);
      console.error('🔍 [Suggestions] Error response status:', error.response.status);
    }
    throw error;
  }
};

export const addProfilesToSuggestions = async (profileIds) => {
  try {
    console.log('🔍 [Suggestions] Adding profiles to suggestions:', profileIds);
    
    const response = await apiClient.post('/profiles/suggestion/add-profiles', {
      profileIds: profileIds
    });
    
    console.log('🔍 [Suggestions] Add response:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('🔍 [Suggestions] Error adding profiles to suggestions:', error);
    if (error.response) {
      console.error('🔍 [Suggestions] Error response data:', error.response.data);
      console.error('🔍 [Suggestions] Error response status:', error.response.status);
    }
    throw error;
  }
};

// Get existing suggestions with optional city filter
export const getExistingSuggestions = async (page = 1, limit = 100, cityFilter = null) => {
  try {
    console.log('🔍 [Suggestions] Fetching existing suggestions page:', page, 'limit:', limit, 'city:', cityFilter);
    
    // Build query parameters
    const params = new URLSearchParams({
      pagination: 'true',
      page: page.toString(),
      limit: limit.toString(),
      includePreviewSong: 'true'  // Request preview songs to be included
    });
    
    // Add city filter if provided (use cityName for string-based filtering)
    if (cityFilter) {
      params.append('cityName', cityFilter);
    }
    
    // Load suggestions with pagination and optional city filter - USE FEED ENDPOINT THAT HAS PREVIEWSONG
    const response = await apiClient.get(`/profiles/suggestion/feed?${params.toString()}`);
    console.log('🔍 [Suggestions] Existing suggestions response:', response.data);
    console.log('🔍 [Suggestions] First suggestion structure:', response.data?.data?.[0]);
    console.log('🔍 [Suggestions] Preview song check:', response.data?.data?.[0]?.previewSong);
    
    return response.data;
  } catch (error) {
    console.error('🔍 [Suggestions] Error fetching existing suggestions:', error);
    if (error.response) {
      console.error('🔍 [Suggestions] Error response data:', error.response.data);
      console.error('🔍 [Suggestions] Error response status:', error.response.status);
    }
    throw error;
  }
};

// Remove suggestion from existing suggestions
export const removeSuggestion = async (profileIds) => {
  try {
    console.log('🔍 [Suggestions] Removing suggestions:', profileIds);
    console.log('🔍 [Suggestions] Profile IDs type:', typeof profileIds);
    console.log('🔍 [Suggestions] Profile IDs is array:', Array.isArray(profileIds));
    
    const requestData = {
      profileIds: Array.isArray(profileIds) ? profileIds : [profileIds]
    };
    console.log('🔍 [Suggestions] Request data being sent:', requestData);
    
    const response = await apiClient.delete('/profiles/suggestion/remove-profiles', {
      data: requestData
    });
    console.log('🔍 [Suggestions] Remove response:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('🔍 [Suggestions] Error removing suggestions:', error);
    if (error.response) {
      console.error('🔍 [Suggestions] Error response data:', error.response.data);
      console.error('🔍 [Suggestions] Error response status:', error.response.status);
    }
    throw error;
  }
};

// Move suggestion up in order
export const moveSuggestionUp = async (suggestionId) => {
  try {
    console.log('🔍 [Suggestions] Moving suggestion up:', suggestionId);
    
    const response = await apiClient.put(`/profiles/suggestion/${suggestionId}/move-up`);
    console.log('🔍 [Suggestions] Move up response:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('🔍 [Suggestions] Error moving suggestion up:', error);
    if (error.response) {
      console.error('🔍 [Suggestions] Error response data:', error.response.data);
      console.error('🔍 [Suggestions] Error response status:', error.response.status);
    }
    throw error;
  }
};

// Move suggestion down in order
export const moveSuggestionDown = async (suggestionId) => {
  try {
    console.log('🔍 [Suggestions] Moving suggestion down:', suggestionId);
    
    const response = await apiClient.put(`/profiles/suggestion/${suggestionId}/move-down`);
    console.log('🔍 [Suggestions] Move down response:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('🔍 [Suggestions] Error moving suggestion down:', error);
    if (error.response) {
      console.error('🔍 [Suggestions] Error response data:', error.response.data);
      console.error('🔍 [Suggestions] Error response status:', error.response.status);
    }
    throw error;
  }
};

// Update preview song for a profile in suggestions collection
export const updateProfilePreviewSong = async (profileId, previewSong) => {
  try {
    console.log('🔍 [Suggestions] Updating preview song for profile:', profileId, 'URL:', previewSong);
    
    const response = await apiClient.patch(`/profiles/suggestion/${profileId}`, {
      previewSong
    });
    console.log('🔍 [Suggestions] Update preview song response:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('🔍 [Suggestions] Error updating preview song:', error);
    if (error.response) {
      console.error('🔍 [Suggestions] Error response data:', error.response.data);
      console.error('🔍 [Suggestions] Error response status:', error.response.status);
    }
    throw error;
  }
};

